import { authLogger } from "../utils/logger";import { useEffect, useState } from 'react';
import { authApi } from '../services/api/authApi';
import useAppStore from '../stores/useAppStore';
import { User } from '../types';

export function useSessionInit() {
  const [isInitialized, setIsInitialized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { login, logout } = useAppStore();

  useEffect(() => {
    let isMounted = true;

    const initializeSession = async () => {
      try {
        // First check session storage for a quick restore
        try {
          const isAuthenticatedInStorage = sessionStorage.getItem('isAuthenticated') === 'true';
          const userInStorage = sessionStorage.getItem('user');
          
          if (isAuthenticatedInStorage && userInStorage) {
            const userData = JSON.parse(userInStorage) as User;
            
            // Check if firstName and lastName are N/A or Unavailable and set useIcon flag
            if (userData.firstName === 'N/A' || userData.lastName === 'N/A') {
              userData.useIcon = true;
              userData.initials = ''; // Empty initials to force icon usage
              userData.name = 'Unknown'; // Set name to Unknown when both first and last names are default values
            }
            
            if (isMounted) {
              login(userData);
            }
          }
        } catch (storageError) {
          authLogger.error('Error checking session storage:', storageError);
        }
        
        // Then check for existing session in Cognito
        const existingSession = await authApi.checkSession();
        
        if (isMounted) {
          if (existingSession) {
            // Always check fresh session from Cognito instead of relying on stored data
            try {
              const freshSession = await authApi.checkSession();
              
              if (freshSession && freshSession.success) {
                login(freshSession.user);
              } else {
                // Fallback to stored session if fresh check fails
                login(existingSession.user);
              }
            } catch (error) {
              authLogger.error('Error checking fresh session:', error);
              // Fallback to stored session
              login(existingSession.user);
            }
          } else {
            // Only logout if we didn't find a session in storage
            if (sessionStorage.getItem('isAuthenticated') !== 'true') {
              logout();
            }
          }
          
          setIsInitialized(true);
          setIsLoading(false);
        }
      } catch (error) {
        authLogger.error('Error initializing session:', error);
        
        if (isMounted) {
          // On error, ensure we're logged out
          logout();
          setIsInitialized(true);
          setIsLoading(false);
        }
      }
    };

    initializeSession();

    return () => {
      isMounted = false;
    };
  }, [login, logout]);

  return {
    isInitialized,
    isLoading
  };
}
